import { useReportBlockNodeBuilder } from '@va/dashboard/shared/report-block-nodes';
import { useTranslate } from '@va/localization';
import { AppliedFilters } from '@va/shared/feature-filters';
import { DataViewOption, ReportBlockNodes, ReportBlockProps } from '@va/types/report-block';
import { ReportBlock, ReportBlockNodeIds } from '@va/ui/components/report-block';
import { useMemo } from 'react';
import ManageWebsitesPagination from './ManageWebsitesPagination';
import { ManageWebsitesTable } from './ManageWebsitesTable';

export const REPORT_BLOCK_ID = 'manage-websites-report-block';

export const ManageWebsitesReportBlock = () => {
  const translate = useTranslate();
  const buildReportBlockNode = useReportBlockNodeBuilder();

  const nodes = useMemo<ReportBlockNodes>(
    () => ({
      filterButton: buildReportBlockNode(ReportBlockNodeIds.FILTER_BUTTON),
      pagination: <ManageWebsitesPagination />,
      appliedFilters: <AppliedFilters />,
    }),
    [buildReportBlockNode],
  );

  const visualization = useMemo<ReportBlockProps['visualization']>(
    () => ({
      selectedView: DataViewOption.table,
    }),
    [],
  );

  const visualizationComponents = useMemo<ReportBlockProps['visualizationComponents']>(
    () => ({
      [DataViewOption.table]: ManageWebsitesTable,
    }),
    [],
  );

  return (
    <ReportBlock
      id={REPORT_BLOCK_ID}
      title={translate('standalone.accountSettings.manageWebsites.title')}
      nodes={nodes}
      visualization={visualization}
      visualizationComponents={visualizationComponents}
    />
  );
};
